import { z } from "zod";
import { DmaCalculationState } from "../dma-calculation-state";
import { dmaCalculationResultsDtoSchema } from "./dma-calculation-results.schema";
export const dmaCanceledCalculationStatusDtoSchema = z.object({
    state: z.literal(DmaCalculationState.Canceled),
    jobStartedAt: z.string().datetime({ offset: true }),
    jobFinishedAt: z.string().datetime({ offset: true }),
    partialResults: dmaCalculationResultsDtoSchema,
});
